
// import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react'
// import Select from 'react-select'
import Axios from 'axios';
import { API_BASE_URL, GET_PO_BY_ID, INSERT_PURCHASE_REQ } from '../../../Config';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";

const SubmittedToPO = ({ PRObj }) => {
    
    const [userDataSession, setUserDataSession] = useState([]);

    // #region Getting session😊
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        // const supplierData = JSON.parse(sessionStorage.getItem('filteredDDLData_Supplier'));
        // const categoryData = JSON.parse(sessionStorage.getItem('filteredDDLData_CATEGORY'));
        // const variantypesData = JSON.parse(sessionStorage.getItem('filteredDDLData_variantypes'));
        // const storesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Stores'));

        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            // setStoreData(storesData);
            // setUnitsData(variantypesData);
            // setCategoryData(categoryData);
            // setSuppliersData(supplierData);
            
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    // const [categoryData, setCategoryData] = useState([]);
    // const [storeData, setStoreData] = useState([]);
    // const [unitsData, setUnitsData] = useState([]);
    // const [suppliersData, setSuppliersData] = useState([]);
    // const [productsData, setProductsData] = useState([]);
    const [editProducts, setEditProducts] = useState([]);
    // const [selectedStatus, setSelectedStatus] = useState(null);
    // const [enteredDiscount, setEnteredDiscount] = useState(null);
    // const [estimateAmount, setEstimateAmount] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    // const [selectedCategory, setSelectedCategory] = useState(null);
    // const [selectedDate, setSelectedDate] = useState('');
    // const [selectedExpecDate, setSelectedExpecDate] = useState('');
    // const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [enterNotes, setEnterNotes] = useState(null);
    const [inputValues, setInputValues] = useState([]);
    const [firstData, setFirstData] = useState(null);
  
    // #region getPurchaseRequestDetails 😊
    useEffect(() => {
        setLoading(true);
        if (userDataSession && userDataSession.OrgId && PRObj && PRObj.PurchaseId){
          Axios.get(`${API_BASE_URL}${GET_PO_BY_ID}?UserId=${userDataSession.UserId}&PurchaseId=${PRObj.PurchaseId}`)
            .then(response => {
                if (response.data.Status) {
                    setEditProducts(response.data.ResultData);
                    setFirstData(response.data.ResultData[0]);
                    console.log(response.data.ResultData, 'data geting from po by id');
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error('Error fetching data:', response.data.Message);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching data:', error);
            });
        }
    
    }, [userDataSession, PRObj]);

    // useEffect(() => {
    //     const fetchData = () => {
    //         const requestData = {
    //             OrgId: userDataSession.OrgId,
    //             Id: 0,
    //             CategoryId: 0,
    //             BarCode: 0,
    //             IsForSale: 1            
    //         };
    //         console.log(requestData, 'Request Data');
        
    //         Axios.post(`${API_BASE_URL}${GET_PROD}`, requestData)
    //           .then(response => {
    //             // Handle the response data as needed
    //             setProductsData(response.data.ResultData);
    //             console.log('Data fetched successfully:', response.data);
    //           })
    //           .catch(error => {
    //             setProductsData([]);
    //             console.error('Error fetching data:', error);
    //           });
    //     };

    //     if (selectedCategory) {
    //         fetchData();
    //     }
    // }, [selectedCategory, userDataSession.OrgId]);
    

    // const handleDateChange = (e) => {
    //     setSelectedDate(e.target.value);
    // };
    // const handleExpectedDateChange = (e) => {
    //     setSelectedExpecDate(e.target.value);
    // };

    // const handleCategoryChange = (selectedOption) => {
    //     setSelectedCategory(selectedOption);
    // };

    // const handleSupplierChange = (date) => {
    //     setSelectedSupplier(date);
    // };

    // const handleStatusChange = (selectedOption) => {
    //     setSelectedStatus(selectedOption);
    // };

    // const handleAddProduct = (selectedOption) => {
    //     const selectedProduct = productsData.find(prod => prod.Id === selectedOption.value);
    //     if (selectedProduct && !editProducts.find(prod => prod.ProductId === selectedProduct.Id)) {
    //         setEditProducts([...editProducts, { ...selectedProduct, Quantity: 1, Comments: '', UnitPrice: '', Units: '', Tax: '' }]);
    //     }
    // };    
    
    // #region Edit Submit 🥵
    const handleSubmit = (e) => {
        e.preventDefault();

        console.log(editProducts, 'products data sending to api')
    
        const requestPayload = {
            orgid: userDataSession.OrgId,
            userid: userDataSession.UserId,
            purchaserequest: {
                Id: PRObj.PurchaseId,
                StoreId: PRObj.StoreId,
                SupplierId: PRObj.SupplierId,
                RequestDate: PRObj.RequestDate,
                Notes: enterNotes,
                Status: "SUBMITTED",
                PStatus: "DRAFT",
                // PODate: selectedDate,
                // ExpectedDate: selectedExpecDate,
                // EstimateAmount: estimateAmount,
                // DiscountAmount: enteredDiscount,
            },
            productdetails: editProducts.map((prod, index) => ({
                detailid: prod.PurchaseDetailId ? prod.PurchaseDetailId : 0,
                ProductId: prod.ProductId ? prod.ProductId : prod.Id,
                Quantity: inputValues[index]?.Quantity || prod.Quantity,
                UOM: prod.UOM ? prod.UOM : null,
                UnitPrice: inputValues[index]?.UnitPrice || prod.UnitPrice,
                CGST: prod.CGST ? prod.CGST : null,
                SGST: prod.SGST ? prod.SGST : null,
                IGST: prod.IGST ? prod.IGST : null,
                CGSTRate: prod.CGSTRate ? prod.CGSTRate : null,
                SGSTRate: prod.SGSTRate ? prod.SGSTRate : null,
                IGSTRate: prod.IGSTRate ? prod.IGSTRate : null,
            }))
        };

        console.log(requestPayload, 'sending payload to api');

        setSubmitLoading(true);
    
        Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_REQ}`, requestPayload)
            .then(response => {
                const data = response.data;
                if (data[0].Success == 1) {
                    setSubmitLoading(false);
                    Swal.fire({
                        title: 'Success',
                        text: 'Request Submitted to Purchase Order successfully.',
                        icon: 'success',
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: 'Failed to update purchase order.',
                        icon: 'error',
                    });
                }
            })
            .catch(error => {
                setSubmitLoading(false);
                console.error("Error:", error);
            });
    };
    
    // #region Delete
    const handleDelete = (index) => {
        console.log(index);
        setEditProducts(prevData => prevData.filter((_, i) => i !== index));
    };

    const handleInputChange = (index, field, value) => {
        setInputValues({
            ...inputValues,
            [index]: {
                ...inputValues[index],
                [field]: value
            }
        });
    };

    // const calculateAmount = (quantity, unitPrice) => {
    //     const parsedQuantity = parseFloat(quantity) || 0;
    //     const parsedUnitPrice = parseFloat(unitPrice) || 0;
    //     return parsedQuantity * parsedUnitPrice;
    // };
    
     
    return (
        <div>
            {/* Add Purchase */}
            <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="offcanvasRightSubmitToPO"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: "45%", maxWidth: "45%" }}
        >
            <div className="offcanvas-header">
            <h4 id="offcanvasRightLabel">Submit to PO (PR{firstData ? firstData.AutoGenTransactionNo : ''})</h4>
            <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
            </div>{" "}
            <hr />
            <div className="offcanvas-body">
                {loading ? 
                <div className='loader m-auto'></div> :
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="input-blocks add-product">
                                <label>Supplier Name</label>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12 col-12">
                                    <input
                                        className='form-control'
                                        value={PRObj && PRObj.SupplierName}
                                        readOnly
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="input-blocks add-product">
                                <label>Store Name</label>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12 col-12">
                                    <input
                                        className='form-control'
                                        value={PRObj && PRObj.StoreName}
                                        readOnly
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="input-blocks">
                                <label>Date</label>
                                <div className="input-groupicon calender-input">
                                    <input 
                                        type='date'
                                        className='form-control'
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="input-blocks">
                                <label>Expected Date</label>
                                <div className="input-groupicon calender-input">
                                    <input 
                                        type='date'
                                        className='form-control'
                                        value={selectedExpecDate}
                                        onChange={handleExpectedDateChange}
                                    />
                                </div>
                            </div>
                        </div> */}
                        {/*
                        <div className='col-lg-3 col-md-6 col-sm-12'>
                            <div className="input-blocks me-3">
                                <label className="form-label">Status</label>
                                <Select 
                                    options={status} 
                                    style={customStyles}
                                    className="select" 
                                    placeholder="Choose"
                                    onChange={handleStatusChange}
                                />
                            </div>
                        </div>
                        */}
                    </div>
                    {/* <div className='row'>
                        <div className="col-lg-3 col-md-3">
                            <div className="input-blocks">
                                <label>Category</label>
                                <Select
                                    className="select"
                                    id="categorySelect"
                                    style={customStyles}
                                    value={selectedCategory}
                                    onChange={handleCategoryChange}
                                    options={categoryData.map(cat => ({
                                    value: cat.ItemId,
                                    label: cat.ItemValue 
                                    }))}
                                    placeholder="Choose Category"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="input-blocks">
                                <label>Products</label>
                                <Select 
                                    className='select'
                                    style={customStyles}
                                    options={productsData.map((prod) => ({
                                        value: prod.Id,
                                        label: prod.ProductName,
                                    }))}
                                    onChange={handleAddProduct}
                                />
                            </div>
                        </div>
                    </div> */}
                    <div className="row mb-2">
                        <div className="col-lg-12">
                            <div className="modal-body-table" style={{ minHeight: '20rem', overflowY: 'auto' }}>
                                <div className="table-responsive" >
                                    <table className="table  datanew">
                                        <thead className='sticky-top'>
                                            <tr>
                                                <th>#</th>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                                {/* <th>Unit Price</th> */}
                                                {/* <th>Units</th> */}
                                                {/* <th>Tax</th> */}
                                                {/* <th>Amount</th> */}
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {editProducts.length !== 0 ? editProducts.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.ProductName}</td>
                                                    <td>
                                                        <input 
                                                            type='number'
                                                            className='form-control'
                                                            placeholder='Quantity'
                                                            value={inputValues[index]?.Quantity || item.Quantity}
                                                            onChange={(e) => handleInputChange(index, 'Quantity', e.target.value)}
                                                            style={{ width: '8rem' }}
                                                            readOnly
                                                        />
                                                    </td>
                                                    {/* <td>
                                                        <input 
                                                            type='number'
                                                            style={{ width: '8rem' }}
                                                            value={inputValues[index]?.UnitPrice || item.UnitPrice}
                                                            className='form-control'
                                                            onChange={(e) => handleInputChange(index, 'UnitPrice', e.target.value)}
                                                            readOnly
                                                        />
                                                    </td> */}
                                                    {/* <td>
                                                        {item.Units}
                                                    </td> */}
                                                    {/* <td>
                                                        {item.Taxes}
                                                    </td> */}
                                                    {/* <td>{calculateAmount(inputValues[index]?.Quantity || item.Quantity, inputValues[index]?.UnitPrice || item.UnitPrice)}</td> */}
                                                    <td>
                                                        <button
                                                            className="btn border text-danger"
                                                            onClick={() => handleDelete(index)}
                                                        >
                                                            <i className="feather-trash-2 fs-6"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No Data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>     
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="input-blocks">
                                    <label>Shipment Details</label>
                                    <textarea 
                                        placeholder='Enter notes'
                                        onChange={(e) => {setEnterNotes(e.target.value)}}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="mt-auto d-flex justify-content-end p-3">
                        <button
                            type="button"
                            className="btn btn-cancel me-2"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            disabled={submitLoading}
                        >
                            Cancel
                        </button>
                        <button className='btn btn-primary me-2'  disabled={submitLoading}>{submitLoading ? 'Submitting...' : 'Submit'}</button>
                        {/* <button className='btn btn-info me-2'>Save & Add Stock</button> */}
                    </div>
                </form>
            }
            </div>
        </div>
    </div>
    )
}

SubmittedToPO.propTypes = {
    PRObj: PropTypes.object.isRequired,
};

export default SubmittedToPO
